const headers = {
  name: "Inventory transfer",
  navigate: {
    tabs: [
      {
        name: "Transfer",
        path: "/app/inventory/transfer",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
